import { Combobox, InputBase, Input, useCombobox, Group } from "@mantine/core"

import { MetricsDatasourceResponses } from "@costory/types/endpoints/metricsDatasources"

import {
  CsvSvgComponent,
  GsheetSvgComponent,
  DatadogSvgComponent,
  AwsSvgComponent,
  BigquerySvgComponent,
  GcsSvgComponent,
} from "@costory/front/components/DatasourceImages"

const typeToIcon = {
  CSV: CsvSvgComponent,
  GoogleSheet: GsheetSvgComponent,
  Datadog: DatadogSvgComponent,
  DatadogCIVisibility: DatadogSvgComponent,
  AWS: AwsSvgComponent,
  BigQuery: BigquerySvgComponent,
  GCS: GcsSvgComponent,
}

interface MetricsDatasourcesSelectProps {
  value?: string
  onChange: (value: string | null) => void
  data: MetricsDatasourceResponses.GetAllMetrics
}

export const MetricsDatasourcesSelect = ({
  value,
  onChange,
  data,
}: MetricsDatasourcesSelectProps) => {
  const combobox = useCombobox({})
  const options = data.map((item) => {
    const Icon = typeToIcon[item.type]
    return (
      <Combobox.Option value={item.id} key={item.id}>
        <Group>
          <Icon width="20px" height="20px" />
          {item.name}
        </Group>
      </Combobox.Option>
    )
  })
  const currentItem = data.find((item) => item.id === value)
  const IconDatasource = currentItem && typeToIcon[currentItem?.type ?? ""]
  return (
    <Combobox
      store={combobox}
      withinPortal={false}
      onOptionSubmit={(val) => {
        onChange(val)
        combobox.closeDropdown()
      }}
    >
      <Combobox.Target>
        <InputBase
          component="button"
          type="button"
          pointer
          leftSection={
            IconDatasource && <IconDatasource width="20px" height="20px" />
          }
          rightSection={<Combobox.Chevron />}
          onClick={() => combobox.toggleDropdown()}
          rightSectionPointerEvents="none"
          required
          error={!currentItem}
        >
          {currentItem?.name || (
            <Input.Placeholder>Pick value</Input.Placeholder>
          )}
        </InputBase>
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options>{options}</Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  )
}
